import React, { Component } from 'react';
//import { Route } from 'react-router';
import { Route, Redirect, Switch } from 'react-router-dom';
import { Layout } from './components/Layout';

import { LoginPage } from './components/LoginPage';


import { ContactUs } from './components/ContactUs';
import { SuccessStory } from './components/SuccessStory';
import { SuccessStoryDetail } from './components/SuccessStoryDetail';
import { Product } from './components/Product';
import { SuccessStoryAdm } from './components/SuccessStoryAdm';
import { SuccessStoryEdit } from './components/SuccessStoryEdit';
import { ProductAdm } from './components/ProductAdm';
import { ProductEdit } from './components/ProductEdit';


import { PrivateRoute } from './components/PrivateRoute';


import { FirebaseContext } from './components/firebase/Context';


import './custom.css'

export default class App extends Component {
    static displayName = App.name;
    static contextType = FirebaseContext;


    constructor(props) {
        super(props);
        this.state = {
            isAuth: false
        }

    }

    componentWillMount() {
        this.context.firebase.auth.onAuthStateChanged((user) => {
            if (user) {
                this.setState({ isAuth: true });
            }
            else {
                this.setState({ isAuth: false });
            }
        });
    }

    render() {
        return (
            <Layout>
                <Switch>
                    <Route exact path='/' component={Product} />
                    <Route exact path='/login' component={LoginPage} />
                    <Route exact path='/contactus' component={ContactUs} />
                    <Route path='/products' component={Product} />
                    <Route path='/success-stories' component={SuccessStory} />
                    <Route path='/success-story-detail' component={SuccessStoryDetail} />

                    <PrivateRoute path='/success-story-adm' component={SuccessStoryAdm} isAuth={this.state.isAuth} exact />
                    <PrivateRoute path='/success-story-edit' component={SuccessStoryEdit} isAuth={this.state.isAuth} exact />
                    <PrivateRoute path='/product-adm' component={ProductAdm} isAuth={this.state.isAuth} exact />
                    <PrivateRoute path='/product-edit' component={ProductEdit} isAuth={this.state.isAuth} exact />
                </Switch>
            </Layout>
        );
    }
}
